import ObjectRoutes from './ObjectRoutes';
import ReportRoutes from './ReportRoutes';
import SetupRoutes from './SetupRoutes';

export { ObjectRoutes, ReportRoutes, SetupRoutes };



// WEBPACK FOOTER //
// ./src/components/page/MainContent/components/index.js